import React from 'react';
import IconProps from '../../icons';

interface CheckCircleDefaultProps extends IconProps {
  colorSecondary?: string;
}

const CheckCircleDefault = ({
  width = 24,
  color = 'var(--success-100)',
  colorSecondary = 'var(--success-600)',
}: CheckCircleDefaultProps): JSX.Element => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    viewBox='0 0 24 24'
    fill='none'
  >
    <path
      d='M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z'
      fill={color}
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M17.0965 7.39004L9.9365 14.3L8.0365 12.27C7.6865 11.94 7.1365 11.92 6.7365 12.2C6.3465 12.49 6.2365 13 6.4765 13.41L8.7265 17.07C8.9465 17.41 9.3265 17.62 9.7565 17.62C10.1665 17.62 10.5565 17.41 10.7765 17.07C11.1365 16.6 18.0065 8.41004 18.0065 8.41004C18.9065 7.49004 17.8165 6.68004 17.0965 7.38004V7.39004Z'
      fill={colorSecondary}
    />
  </svg>
);

export default CheckCircleDefault;
